import { TradeInIcon } from '@/components/deal/trade/deal-trade-ins';
import { COMBO_BOX_OPTIONS_2 } from '../combobox-popovers/all-filters-combobox-popover';
import type { TradeInFilterChipProps, TradeInFiltersState } from '../types';
import BaseFilterChip from './base-filter-chip';

const TradedInFilterChip = (props: TradeInFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    // TODO: fix the type
    <BaseFilterChip<'trade_in', TradeInFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={({ children }) => <div>{children}</div>}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_2.find((option) => option.value === 'traded_in')?.icon
      }
      filterName="Buyer's car"
      filterQuantifier={{
        singular: 'Traded-in',
        plural: 'Traded-in',
      }}
      SelectedFilterBadge={() => <TradeInIcon className="size-3.5" />}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      hideFilterComboBoxPopover
    />
  );
};

export default TradedInFilterChip;
